var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2198 10.2192C10.3605 10.0786 10.5512 9.99961 10.7501 9.99961C10.949 9.99961 11.1397 10.0786 11.2803 10.2192L14.5001 13.439L17.7198 10.2192C17.789 10.1476 17.8718 10.0904 17.9633 10.0511C18.0548 10.0118 18.1532 9.99113 18.2528 9.99026C18.3524 9.9894 18.4511 10.0084 18.5433 10.0461C18.6355 10.0838 18.7192 10.1395 18.7896 10.2099C18.8601 10.2803 18.9157 10.3641 18.9535 10.4562C18.9912 10.5484 19.0101 10.6472 19.0093 10.7468C19.0084 10.8463 18.9877 10.9448 18.9484 11.0363C18.9091 11.1278 18.852 11.2105 18.7803 11.2797L15.5606 14.4995L18.7803 17.7192C18.917 17.8607 18.9925 18.0501 18.9908 18.2468C18.9891 18.4434 18.9103 18.6315 18.7712 18.7706C18.6321 18.9096 18.444 18.9885 18.2474 18.9902C18.0507 18.9919 17.8613 18.9163 17.7198 18.7797L14.5001 15.5599L11.2803 18.7797C11.1389 18.9163 10.9494 18.9919 10.7528 18.9902C10.5561 18.9885 10.368 18.9096 10.229 18.7706C10.0899 18.6315 10.011 18.4434 10.0093 18.2468C10.0076 18.0501 10.0832 17.8607 10.2198 17.7192L13.4396 14.4995L10.2198 11.2797C10.0792 11.1391 10.0002 10.9483 10.0002 10.7495C10.0002 10.5506 10.0792 10.3598 10.2198 10.2192Z",
    fill: "#9CA3AF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.85,
    stroke: "#9CA3AF",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.f42c73ca0e9eab68213c492949666251.svg";
export { ForwardRef as ReactComponent };